import UAParser from './userAgentParser';
import BrowserFeaturesComponent from './browserFeaturesComponent';
import $ from '../../../FrontendBundle/Resources/js/jquery';

window.initializeFeatureBundle = function initializeFeatureBundle(element, messages) {
    const component = new BrowserFeaturesComponent($(element), new UAParser(navigator.userAgent), messages);
    const supportedBrowsers = SUPPORTED_BROWSERS
        .filter(identifier => /(chrome|edge|firefox|ie|safari) .*$/.test(identifier));

    component.render(supportedBrowsers, window.screen);
};
